import { CantileverButton } from 'components/CantileverButton'
import { DetectionModelCard } from 'features/anomalyDetection/components/DetectionModelCard'
import { EditDetectionConfigurationInfoCard } from 'features/anomalyDetection/components/EditDetectionConfigurationInfoCard'
import { EditDetectionConfigurationDataLayer } from 'features/anomalyDetection/contexts/EditDetectionConfigurationDataLayer'
import {
  EditDetectionConfigurationUXContext,
  EditDetectionConfigurationUXLayer,
} from 'features/anomalyDetection/contexts/EditDetectionConfigurationUXLayer'
import { GeckoNotificationProvider } from 'features/notifications'
import React, { useContext } from 'react'
import styled from 'styled-components'

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`

interface EditDetectionConfigurationProps {
  siteID: string
  detectionConfigurationId: string
}

const EditDetectionConfigurationContent: React.FC = () => {
  const { submitConfig, isLoading } = useContext(
    EditDetectionConfigurationUXContext
  )
  return (
    <>
      <CardsContainer>
        <EditDetectionConfigurationInfoCard />
        <DetectionModelCard />
      </CardsContainer>
      <SubmitButtonContainer>
        <CantileverButton onClick={submitConfig} disabled={isLoading} primary>
          {isLoading ? 'Saving...' : 'Save Configuration'}
        </CantileverButton>
      </SubmitButtonContainer>
    </>
  )
}

export const EditDetectionConfiguration: React.FC<
  EditDetectionConfigurationProps
> = ({ siteID, detectionConfigurationId }) => {
  return (
    <GeckoNotificationProvider>
      <EditDetectionConfigurationDataLayer
        siteID={siteID}
        detectionConfigurationId={detectionConfigurationId}>
        <EditDetectionConfigurationUXLayer>
          <EditDetectionConfigurationContent />
        </EditDetectionConfigurationUXLayer>
      </EditDetectionConfigurationDataLayer>
    </GeckoNotificationProvider>
  )
}
